<main>
  <kl-digital-assist-profile-update (profileFullView)="ok()">

  </kl-digital-assist-profile-update>
</main>
